import { RVOptions } from '@railzai/railz-visualizations';

import { ALL_FONTS } from 'providers/theme-provider';

export const chartOptions: RVOptions = {
  chart: { fontFamily: ALL_FONTS },
};
